import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { AuthService } from './auth.service';

declare var ripple: any;

/*
  Generated class for the XrplProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable({
  providedIn: 'root'
})


export class XprlService {

  public static MY_PUBLIC;
  public accountReady:boolean;
  
  public static B1X_XRP_RATIO = 1000;

  public xrplApi: any;
  public wallet: any;
  public market: any;
  public currentBlockHash = 'Connecting...';
  public currentBlockDate: Date;
  public hasFCX:boolean;
  public currentXRPaccount:any;

  allMyClaims = [];
  allMyExceptions = [];
  exceptionForCurrentReward;

  loadingWindow:any;


  constructor(private auth:AuthService, public loadingController:LoadingController) {

    // this.init();
  }

  async isWalletValid(publicKey)
  {
    console.log('? isWalletValid', publicKey);
    if(this.xrplApi.isValidAddress(publicKey)) return true;
    else return false;
  }

  init()
  {
    this.wallet = {};
    this.market = {};

    this.xrplApi = new ripple.RippleAPI({ server: 'wss://xrplcluster.com' });
    this.xrplApi.on('connected', () => {
      console.log('Connection is open now.');
    });

    this.xrplApi.on('disconnected', (code) => {
      if (code !== 1000) {
        console.log('Connection is closed due to error.');
      } else {
        console.log('Connection is closed normally.');
      }
    });

    this.xrplApi.on('ledger',  ledger => {
      
      this.currentBlockHash = JSON.stringify(ledger.ledgerHash, null, 2);
      this.currentBlockDate = new Date(ledger.ledgerTimestamp);
      // console.log('ledger:', this.currentBlockHash, this.currentBlockDate);
    });

    }


    async getAccountLines(publicKey)
    {
      await this.sleep(1500);
      console.log('kick LINES');

      XprlService.MY_PUBLIC = publicKey;

      this.xrplApi.connect().then(() => {
        /* begin custom code ------------------------------------ */
        //console.log('1. getting lines for', publicKey);
        return this.xrplApi.getTrustlines(publicKey);
        }).then(lines => {
          //console.log('2. got getXRP lines', lines);

          lines.forEach(line => {
            if(line.specification.currency === 'FCX' && line.specification.counterparty === 'rwSgqza9DUzr8oPDkJz8xUbPbaxAyoeLus')
            {
              console.log('FCX TL',line.state.balance); 
              if(!this.currentXRPaccount)
              {
                this.currentXRPaccount = {};
              }
              this.currentXRPaccount.fcx                  = parseInt(line.state.balance);
              console.log('ile FCX', this.currentXRPaccount.fcx)
              this.currentXRPaccount.issuer               = line.specification.counterparty;
              console.log('3. jest FCX TL', this.currentXRPaccount);
              this.hasFCX = true;

              console.log('TEST CURRENT CLAIMA dla ', XprlService.MY_PUBLIC, this.auth.currentRewardID);

              this.auth.getAllClaimsForWallet(XprlService.MY_PUBLIC).subscribe
              (allClaims => {
                //console.log('claims', allClaims);
                this.allMyClaims = allClaims;
                this.allMyClaims.forEach(claimelement => {
                  claimelement.isVisible = false;
                });
              })

              this.auth.getAllExceptionsForWallet(XprlService.MY_PUBLIC).subscribe
              (allExceptions => {
                
                this.allMyExceptions = allExceptions;
                this.allMyExceptions.forEach(eXelement => {
                  if(eXelement.exception && eXelement.exception.currentReward == this.auth.currentRewardID)
                  {
                    console.log('exception for this reward', eXelement);
                    this.exceptionForCurrentReward = eXelement;
                  }
                });
              })

              this.auth.getCurrentClaimDataByCurrentNUM(this.auth.currentRewardID).subscribe( (currentNumDOc:any)=>{

                //console.log('!!!currentNumDOc', currentNumDOc);

                if(!currentNumDOc) return;

                currentNumDOc.forEach(element => {
                  console.log('WAS CURRENT CLAIM ', element);
                  this.auth.currentClaim = element;
                  if(this.auth.currentClaim.engine_result == 'tefPAST_SEQ')
                  {
                    this.auth.shouldGetManual = true;
                  }
                  else if(this.auth.currentClaim.engine_result == 'terQUEUED')
                  {
                    
                  }
                });
              })
              
            }
          });
          return lines
          // this.start();
        }).catch(e => {
          console.error(e);
          return e
        });
    }
    
    async getTransactionByHash(hashTX:string)
    {
      await this.xrplApi.getTransaction(hashTX).then(info => {
        console.log('getTransactionByHash' + JSON.stringify(info, null, 2));
        return JSON.stringify(info, null, 2);
        // this.loadingProvider.hide();
      });
    }

    async getLedger(hashLedgera: string)
    {
      await this.xrplApi.getLedger(hashLedgera)
        .then(info => {
          console.log('getLedgerInfo' + JSON.stringify(info, null, 2));
          return JSON.stringify(info, null, 2);
          // this.loadingProvider.hide();
      });
    }

    async presentLoading() {
      this.loadingWindow = await this.loadingController.create({
        spinner: 'lines-small',
        message: 'Fetching your FCX/XRP account',
        translucent: true,
        cssClass: 'custom-class custom-loading',
        backdropDismiss: false
      });
      await this.loadingWindow.present();
  
      const { role, data } = await this.loadingWindow.onDidDismiss();
      console.log('Loading dismissed with role:', role);
    }

    async sleep(ms: number) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    async getXRPInfo(publicKey)
    {
      this.presentLoading();

      this.xrplApi.connect().then(() => {
        /* begin custom code ------------------------------------ */
        
        console.log('--getting account info for', XprlService.MY_PUBLIC);

        

        return this.xrplApi.getAccountInfo(publicKey);
        }).then(brama => {
          this.currentXRPaccount = {
            ownerCount : brama.ownerCount,
            previousAffectingTransactionID: brama.previousAffectingTransactionID,
            previousAffectingTransactionLedgerVersion: brama.previousAffectingTransactionLedgerVersion,
            sequence: brama.sequence,
            xrpBalance: parseInt(brama.xrpBalance),
            pubKey: publicKey
          };
          XprlService.MY_PUBLIC = this.currentXRPaccount.pubKey;

          console.log('------------------SAVED----', XprlService.MY_PUBLIC, this.currentXRPaccount);

          this.accountReady = true;
          this.loadingWindow.dismiss();
          return brama
          // this.start();
        }).catch(e => {
          console.error(e);
          return e
        });
    }

    async sendPayment(txData: any)
    {
      await this.xrplApi.sendPayment(txData).then(info => {
        console.log('sendPayment' + JSON.stringify(info, null, 2));
        return JSON.stringify(info, null, 2);
        // this.loadingProvider.hide();
      });
    }
  }

